import { apiRequest, buildApiUrl, API_CONFIG } from '../utils/api';

class CategoryService {
  static normalizeCategoriesResponse(response) {
    const content = response?.response?.content || {};
    return (
      content.categories ||
      content.categoriess ||
      []
    );
  }

  static async getCategories() {
    try {
      const url = buildApiUrl(API_CONFIG.ENDPOINTS.CATEGORIES);
      const response = await apiRequest(url, {
        method: 'GET'
      });

      const categories = CategoryService.normalizeCategoriesResponse(response);

      return {
        success: true,
        categories
      };
    } catch (error) {
      console.error('Error al obtener categorías:', error);
      return {
        success: false,
        error: error.message || 'Error al obtener categorías',
        categories: []
      };
    }
  }

  static async createCategory(name) {
    try {
      const url = buildApiUrl(API_CONFIG.ENDPOINTS.CATEGORIES);
      const response = await apiRequest(url, {
        method: 'POST',
        body: JSON.stringify({ name })
      });

      if (response.response?.message === 'Category created') {
        return {
          success: true,
          categoryId: response.response?.content?.id
        };
      }

      return {
        success: false,
        error: 'No se pudo crear la categoría'
      };
    } catch (error) {
      console.error('Error al crear categoría:', error);
      return {
        success: false,
        error: error.message || 'Error al crear categoría'
      };
    }
  }

  static async updateCategory(id, name) {
    try {
      const url = `${buildApiUrl(API_CONFIG.ENDPOINTS.CATEGORIES)}/${id}`;
      const response = await apiRequest(url, {
        method: 'PUT',
        body: JSON.stringify({ name })
      });

      if (response.response?.message === 'category update successfully') {
        return {
          success: true,
          category: response.response?.content?.category
        };
      }

      return {
        success: false,
        error: 'No se pudo actualizar la categoría'
      };
    } catch (error) {
      console.error('Error al actualizar categoría:', error);
      return {
        success: false,
        error: error.message || 'Error al actualizar categoría'
      };
    }
  }

  static async createTag({ name, categoryId, color }) {
    try {
      const url = buildApiUrl(API_CONFIG.ENDPOINTS.TAGS);
      const payload = {
        name,
        categoryId,
        color
      };

      const response = await apiRequest(url, {
        method: 'POST',
        body: JSON.stringify(payload)
      });

      if (response.response?.message === 'Tag created') {
        return {
          success: true,
          tagId: response.response?.content?.id
        };
      }

      return {
        success: false,
        error: 'No se pudo crear la etiqueta'
      };
    } catch (error) {
      console.error('Error al crear etiqueta:', error);
      return {
        success: false,
        error: error.message || 'Error al crear etiqueta'
      };
    }
  }

  static async updateTag(tagId, { name, categoryId, color }) {
    try {
      const url = `${buildApiUrl(API_CONFIG.ENDPOINTS.TAGS)}/${tagId}`;
      const payload = {
        name,
        categoryId,
        color
      };

      const response = await apiRequest(url, {
        method: 'PUT',
        body: JSON.stringify(payload)
      });

      if (response.response?.message === 'tag update successfully') {
        return {
          success: true,
          tag: response.response?.content?.tag
        };
      }

      return {
        success: false,
        error: 'No se pudo actualizar la etiqueta'
      };
    } catch (error) {
      console.error('Error al actualizar etiqueta:', error);
      return {
        success: false,
        error: error.message || 'Error al actualizar etiqueta'
      };
    }
  }

  static async deleteCategory(id) {
    try {
      const url = `${buildApiUrl(API_CONFIG.ENDPOINTS.CATEGORIES)}/${id}`;
      await apiRequest(url, {
        method: 'DELETE'
      });

      return {
        success: true
      };
    } catch (error) {
      console.error('Error al eliminar categoría:', error);
      return {
        success: false,
        error: error.message || 'Error al eliminar categoría'
      };
    }
  }

  static async deleteTag(tagId) {
    try {
      const url = `${buildApiUrl(API_CONFIG.ENDPOINTS.TAGS)}/${tagId}`;
      const response = await apiRequest(url, {
        method: 'DELETE'
      });

      if (response.response?.message === 'tag delete successfully') {
        return {
          success: true
        };
      }

      return {
        success: false,
        error: 'No se pudo eliminar la etiqueta'
      };
    } catch (error) {
      console.error('Error al eliminar etiqueta:', error);
      return {
        success: false,
        error: error.message || 'Error al eliminar etiqueta'
      };
    }
  }
}

export default CategoryService;

